import React from 'react';
import classNames from 'classnames';

interface Props {
    id: string;
    label?: string;
    legend?: string;
    required?: boolean;
    disabled?: boolean;
    children?: React.ReactElement;
    error?: string;
    type?: string;    
    namespace?: string;
    addStyle?: string;
}

export default (props: Props): React.ReactElement => {
    const style = classNames('input-wrapper', props.namespace, `-${props.type || 'none-type'}`, props.addStyle, {
        '-required': !!props.required,
        '-invalid': !!props.error,
        '-disabled': !!props.disabled,
    });

    return <div className={style}>
        { props.type === 'radio' || props.type === 'checkbox' ? <fieldset>
                <legend>{props.legend || 'Velg et alternativ'}</legend>
                {
                    //Dette er selve checkboxen selv om den er defienert i CheckBox
                    props.children
                }
            </fieldset> : <>
                <label htmlFor={props.id}>{props.label}</label>
                <div className="input-holder">{
                    //tilsvarende her for tekstboks
                    props.children
                }</div>
            </>
        }

        {
            //dette er det som viser feilmelding for den aktuelle inputen som ikke validerer
            !!props.error && <div id={`${props.id}-error`} className="input-wrapper-error-message">
            <span aria-live="polite">{props.error}</span>
        </div> }
    </div>
};
